import React from "react";
import CarList from "./CarsList";
import { scrollToElement } from "./scrollHelpers";

function LandingPage() {
  const scrollToCars = (event) => {
    event.preventDefault();

    const carsSection = document.getElementById("cars-section");
    scrollToElement(carsSection);
  };

  return (
    <div className="landingPage">
      <section className="hero">
        <div className="heroContent">
          <h1>
            Discover Dubai with
            <span>Oh My Car.</span>
          </h1>
          <p className="heroCopy">
            Rent the world's best cars and experience Dubai like never before.
          </p>
          <a className="heroCta" href="#cars-section" onClick={scrollToCars}>
            <span>Explore our cars</span>
            <span aria-hidden="true">-&gt;</span>
          </a>
          <div className="heroFeatures" aria-label="Rental benefits">
            <div>
              <span className="featureIcon">IN</span>
              <span>Insurance included</span>
            </div>
            <div>
              <span className="featureIcon">AED</span>
              <span>Best price guarantee</span>
            </div>
            <div>
              <span className="featureIcon">24</span>
              <span>24/7 support</span>
            </div>
            <div>
              <span className="featureIcon">NO</span>
              <span>No hidden charges.</span>
            </div>
          </div>
        </div>
      </section>
      <section id="cars-section">
        <CarList />
      </section>
    </div>
  );
}

export default LandingPage;
